import { memo, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { themeV5 } from 'theme/v5'

const getStyles = (name, selected) => ({
  fontWeight:
    selected === name === -1
      ? themeV5.typography.fontWeightRegular
      : themeV5.typography.fontWeightMedium,
})

const SingleSelectInline = ({
  noNone,
  options = [],
  value = '',
  onChange,
  ...rest
}) => {

  const [selected, setSelected] = useState(value)

  const onChangeSelection = event =>
    onChange(event.target.value)

  useEffect(() => {
    setSelected(value)
  }, [value])

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
      }}>
      <FormControl
        sx={{
          textAlign: 'left',
          margin: 0,
          padding: 0,
          width: '100%',
          borderRadius: 4,
          border: '1px solid #ced4da',
          '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none !important',
            '& > div': {
              background: themeV5.palette.background.paper,
            },
          },
          '& label': {
            background: themeV5.palette.background.paper,
          },
          '& .MuiInputBase-input': {
            margin: 0,
            padding: '6px 8px !important',
            background: 'none !important',
          },
          '& .MuiOutlinedInput-input': {
            padding: 1.35,
          },
          '& .MuiInputLabel-outlined': {
            transform: 'translate(14px, 14px) scale(1)',
          },
          '& .MuiInputLabel-shrink': {
            transform: 'translate(14px, -6px) scale(0.75)',
          },
        }}
        variant="outlined">
        <Select
          value={selected}
          onChange={onChangeSelection}
          {...rest}>
          { ! noNone && (
            <MenuItem value="">
              <em>No Filter</em>
            </MenuItem>
          )}
          {options.map((option, index) => {

            const name = option.label || option
            const code = option.value || option

            if (option.label && ! option.value) {
              return (
                <MenuItem
                  sx={{
                    paddingTop: '2px !important',
                    paddingBottom: '2px !important',
                    minHeight: '0 !important',
                    background: 'transparent !important',
                  }}
                  key={index}
                  disabled
                  value="">
                  <em>{name}</em>
                </MenuItem>
              )
            }

            return (
              <MenuItem
                key={index}
                value={code}
                style={getStyles(code, selected)}>
                {name}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    </div>
  )
}

SingleSelectInline.propTypes = {
  noNone: PropTypes.bool,
  options: PropTypes.array.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
}

export default memo(SingleSelectInline)
